/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import CampaignIcon from "../../assets/icons/create_inbound.svg2";
import PageHeader from "../Common/PageHeader";
import {
  InboundCampaignType,
  useGetInboundCampaignsQuery,
} from "../store/inboundCampaignSlice";
import MyPagination from "../Common/MyPagination";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { Col, Row } from "react-bootstrap";
import MyBadge from "../Common/MyBadge";
import InboundCampaignCard from "./InboundCampaignCard";
import InboundCampaignDetails from "./ImboundCampaignDetails";
import FullScreenLoadingIndicator from "../Common/FullScreenLoadingIndicator";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import WhiteButton from "../Common/WhiteButton";
import AddIcon from "../../assets/icons/icon_inbound-01.svg2";
import MySearch from "../Common/MySearch";
import InboundCampaignForm from "./InboundCampaignForm";
import HelpButton from "../HelpContent/HelpButton";

const { baseUrl: baseURL, emailDomain } = JSON.parse(
  (document.querySelector("#app") as any).dataset.page
).props;

const getInboundCampaignUuid = (campaign?: InboundCampaignType) =>
  campaign?.Uuid || (campaign as any)?.UUID;

function WorkflowInbounds() {
  const navigate = useNavigate();
  const [filters, setFilters] = useState<{
    limit?: number;
    offset?: number;
    search?: string;
    kind?: string;
    order_by?: "created_at" | "updated_at" | "inbound" | "label" | "hits";
    order?: "asc" | "desc";
    inbound?: string;
    channel?: ("sms" | "email" | "voice")[];
    status?: "active" | "inactive" | "";
    is_wildcard?: boolean;
  }>({
    limit: 12,
    offset: 0,
    search: "",
    kind: "inbound",
    order_by: "created_at",
    order: "desc",
    channel: [],
    status: "active",
    is_wildcard: false,
  });

  const { inboundUUID } = useParams();
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => {
      setFilters({ ...filters, search: searchText, offset: 0 });
    }, 500);
    return () => clearTimeout(timer);
  }, [searchText]);

  const {
    data: { items: inboundRules, total } = { items: [], total: 0 },
    isLoading: loading,
  } = useGetInboundCampaignsQuery(filters);

  const [selectedTemplate, setSelectedTemplate] =
    useState<InboundCampaignType>();
  const selectedTemplateUuid = getInboundCampaignUuid(selectedTemplate);

  useEffect(() => {
    if (!inboundRules?.length) {
      setSelectedTemplate(undefined);
      return;
    }

    const nextSelectedTemplate =
      inboundRules.find((ir) => getInboundCampaignUuid(ir) === inboundUUID) ||
      inboundRules[0];
    const nextSelectedTemplateUuid = getInboundCampaignUuid(nextSelectedTemplate);

    if (nextSelectedTemplateUuid !== selectedTemplateUuid) {
      setSelectedTemplate(nextSelectedTemplate);
    }
  }, [inboundRules, inboundUUID, selectedTemplateUuid]);

  return (
    <>
      <FullScreenLoadingIndicator loading={loading} />
      <PageHeader
        Icon={CampaignIcon}
        heading="Campaign Library"
        subheading="Choose from one of your existing campaigns."
      >
        <div className="d-flex gap-2 align-items-center justify-content-end">
          <WhiteButton
            heading="Add"
            subheading="Inbound Campaign"
            as="RRLink"
            icon={AddIcon}
            to="/inbounds/new"
            disabled={false}
            target={undefined}
          />{" "}
        </div>
      </PageHeader>

      <div className="d-flex justify-content-between my-3 bg-white rounded-3 p-3 align-items-center">
        <div className="d-flex align-items-center gap-2">
          <div>
            <span className="fw-bold p-2">Channel:</span>
          </div>
          <div>
            <Input
              placeholder="Channel"
              inputType="select"
              isMulti
              isClearable
              value={filters.channel ?? []}
              onChange={(v: any[]) => setFilters({ ...filters, channel: v })}
              options={[
                { label: "SMS", value: "sms" },
                { label: "Email", value: "email" },
                { label: "Voice", value: "voice" },
              ]}
            />
          </div>
          <div>
            {" "}
            <span className="fw-bold p-2">Status:</span>
          </div>
          <div>
            <Input
              placeholder="Status"
              inputType="radio"
              radioName="status"
              value={[filters.status]}
              onChange={([v]: any) => setFilters({ ...filters, status: v })}
              options={[
                { label: "All", value: "" },
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
              ]}
            />
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <MySearch
            placeholder="Search"
            value={searchText}
            onChange={(e: {
              target: { value: React.SetStateAction<string> };
            }) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <div className="d-flex justify-content-end flex-wrap "></div>
      <Row className="mb-5 my-3">
        <Col xs={12} lg={4} className="fw-bold pe-5">
          <span className="fs-3">
            {" "}
            Inbound Campaigns
            <HelpButton helpKey="inbound-campaigns" />
          </span>
          <MyBadge count={total} />
          {inboundRules?.map((template, index) => {
            const templateUuid = getInboundCampaignUuid(template);

            return (
              <InboundCampaignCard
                key={templateUuid || index}
                template={template}
                isSelected={selectedTemplateUuid === templateUuid}
                onSelect={() => setSelectedTemplate(template)}
              />
            );
          })}
          <MyPagination
            total={total}
            onPaginate={(page: number, perPage: number) => {
              setFilters((p) => ({
                ...p,
                offset: page * perPage,
                limit: perPage,
              }));
            }}
          />
        </Col>
        <div className="col-lg-1"></div>
        <Col className="fw-bold">
          {selectedTemplate && (
            <>
              <InboundCampaignDetails selectedTemplate={selectedTemplate} />
            </>
          )}
        </Col>
      </Row>
      {inboundUUID && (
        <InboundCampaignForm
          uuid={inboundUUID}
          onClose={() => navigate("/inbounds")}
        />
      )}
    </>
  );
}

export default WorkflowInbounds;
